import { ReactNode } from "react";
import ProjectManager from "./ProjectManager";
import Configuration from "./Configuration";

interface SectionContentProps {
  activeSection: string;
}

const SectionContent: React.FC<SectionContentProps> = ({ activeSection }) => {
  const renderSectionContent = (): ReactNode => {
    switch (activeSection) {
      case "workspace":
        return <ProjectManager />;

      case "settings":
        return <Configuration />;

      default:
        return <ProjectManager />;
    }
  };

  return <>{renderSectionContent()}</>;
};

export default SectionContent;
